import { useState } from 'react';
import { useScreenStore } from '@/state/screenStore';
import { buttonClass } from '@/ui/button';
import { importYouTube } from './importYouTube';
import { youtubeId } from './youtubeId';
import styles from './YouTubeLinkForm.module.css';

/** "Or paste a YouTube link" under the drop zone: the song opens in the player like a file. */
export function YouTubeLinkForm() {
  const showImport = useScreenStore((s) => s.showImport);
  const [link, setLink] = useState('');
  const [error, setError] = useState<string | null>(null);

  return (
    <form
      className={styles.form}
      onSubmit={(e) => {
        e.preventDefault();
        const id = youtubeId(link);
        setError(id ? null : 'That doesn’t look like a YouTube video link.');
        if (!id) return;
        void importYouTube(id);
        setLink('');
        showImport();
      }}
    >
      <span className={styles.or}>or paste a YouTube link</span>
      <div className={styles.row}>
        <input
          className={styles.input}
          type="url"
          inputMode="url"
          placeholder="https://www.youtube.com/watch?v=…"
          aria-label="YouTube link"
          value={link}
          onChange={(e) => {
            setLink(e.target.value);
          }}
        />
        <button type="submit" className={buttonClass('primary')}>
          Get chords
        </button>
      </div>
      {error && (
        <span className={styles.error} role="alert">
          {error}
        </span>
      )}
      <span className={styles.note}>
        The link goes to the KnowYourChord server, which works out the chords. Your files never
        leave this device.
      </span>
    </form>
  );
}
